import React from 'react';
import PropTypes from 'prop-types';
import useForm from '@afosto/utils-react/validation/useForm';
import useIntl from '@afosto/utils-react/intl/useIntl';
import ClientSearch from '@afosto/app-components-react/ClientSearch';
import Form from '@afosto/app-components-react/Form';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import Select from '@afosto/app-components-react/Select';
import TextField from '@afosto/app-components-react/TextField';
import validationSchema from './validations';
import translations from './translations';

const CHANNEL_TYPES = {
  pos: {
    scopes: ['odr:orders:write'],
  },
  storefront: {
    scopes: [],
  },
  order: {
    scopes: ['odr:orders:write'],
  },
  integration: {
    scopes: [],
  },
};

const ChannelForm = ({ channel, onCancel, onSubmit }) => {
  const intl = useIntl();
  const form = useForm({
    validationSchema,
    defaultValues: {
      name: channel?.name ?? '',
      description: channel?.description ?? '',
      type: channel?.type ?? '',
      client: channel?.client_id ?? null,
    },
    onCancel,
    onSubmit,
  });
  const { setValue, watch } = form;
  const clientValue = watch('client');
  const typeValue = watch('type');
  const clientScopes = CHANNEL_TYPES[typeValue]?.scopes ?? [];
  const clientRequired = !['pos', 'order'].includes(typeValue);

  const handleChangeClient = (event, newClient) => {
    setValue('client', newClient);
    setValue('description', '');

    if (newClient) {
      setValue('name', newClient?.name);
    }
  };

  const handleChangeType = (event, newType) => {
    setValue('type', newType);
    setValue('client', null);
    setValue('name', '');
    setValue('description', '');
  };

  return (
    <LoadingWrapper isLoading={form?.isLoading}>
      <Form form={form}>
        {!channel && (
          <>
            <Select
              name="type"
              label={intl.formatMessage(translations.fields.type)}
              suggestions={Object.keys(CHANNEL_TYPES).map(type => ({
                label: intl.formatMessage(translations.types[type]),
                value: type,
              }))}
              onChange={handleChangeType}
            />
            {typeValue && clientRequired && (
              <ClientSearch
                name="client"
                label={intl.formatMessage(translations.fields.client)}
                onChange={handleChangeClient}
                scopes={clientScopes}
                enableCreate={false}
              />
            )}
          </>
        )}
        <TextField
          name="name"
          label={intl.formatMessage(translations.fields.name)}
          disabled={!typeValue || (!clientValue && clientRequired)}
        />
        <TextField
          name="description"
          label={intl.formatMessage(translations.fields.description)}
          disabled={!typeValue || (!clientValue && clientRequired)}
        />
      </Form>
    </LoadingWrapper>
  );
};

ChannelForm.propTypes = {
  channel: PropTypes.object,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

ChannelForm.defaultProps = {
  channel: undefined,
  onCancel: undefined,
  onSubmit: undefined,
};

export default ChannelForm;
